const initialValues = {

    title: "",
    company: "",
    shasiNo: "",
    productYear: "",
    kilometer: "",
    distancePerWeek: "",
    useFuel: "",
    pelak1: "",
    pelak2: 1,
    pelak3: "",
    pelak4: "",
    imageFile: null,
    //////////
    imageUrl: "",
    userId: "",
};

export default initialValues;